import { revealStyle, useStagedReveal } from '@odo/shared-ui';
import { PartSlideText } from './PartSlideText';
import { youTubeNoCookieEmbedUrl, type VideoPart } from './types';

interface VideoPartSlideProps {
    part: VideoPart;
}

// Rises alongside the title so the video doesn't wait for all three takeaways.
const VIDEO_REVEAL_DELAY_MS = 300;
const VIDEO_RISE_PX = 24;

function PartVideo({ part }: VideoPartSlideProps) {
    return (
        <div className="p-1.5 rounded-2xl bg-gray-50 border border-gray-100 shadow-sm">
            <div className="relative w-full aspect-video rounded-xl overflow-hidden bg-black">
                <iframe
                    key={part.youtubeId}
                    src={youTubeNoCookieEmbedUrl(part.youtubeId)}
                    title={part.title}
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    className="absolute inset-0 w-full h-full border-0"
                />
            </div>
        </div>
    );
}

export function VideoPartSlide({ part }: VideoPartSlideProps) {
    const stage = useStagedReveal(1, VIDEO_REVEAL_DELAY_MS);

    return (
        <div className="grid grid-cols-5 items-center gap-10 w-full">
            <div className="col-span-2">
                <PartSlideText part={part} />
            </div>
            <div
                className="col-span-3 transition-all duration-700 ease-out"
                style={revealStyle(stage >= 1, VIDEO_RISE_PX)}
            >
                <PartVideo part={part} />
            </div>
        </div>
    );
}
